import React from "react";
import InfoColumns from "../Stats/InfoColumns";
import { executeQuery } from "../../requests/executeQuery";
import { STATS_BY_STATUS_HSC } from "../../consts/queries";
import { HscStatsData } from "../HscStats/models/hscstats";
import { TARGET_LIST_MATURING_LOANS } from "../../utils";

export default class PeakPipeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: new HscStatsData({}),
        };
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        executeQuery({ queryName: STATS_BY_STATUS_HSC, params: {} }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data[0]) {
                this.setState({ stats: new HscStatsData({ dataByStatus: res.data[0] }) });
            }
        });
    }

    render() {
        const { stats } = this.state;

        return (
            <div className='Stats'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-header'>
                            <div className='page-title'>Pipeline</div>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='stats-container page-body-container'>
                    <div className='stats-columns'>
                        <div className='stats-column first'>
                            <InfoColumns title={`Loan In Process`}
                                titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Loan In Process`}
                                columns={[
                                    {key: 'Transactions', value: stats.loanInProcessCount},
                                    {key: 'Total Loan Amount', value: stats.loanAmount},
                                    {key: 'Avg Rate', value: stats.loanInProgressAvgrate}
                                ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Courting`}
                                titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Courting`}
                                columns={[
                                    {key: 'Transactions', value: stats.courtingTransactions},
                                    {key: 'Total Loan Amount', value: stats.courtingLoanAmount},
                                    {key: 'Avg Rate', value: stats.courtingAvgRate}
                                ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Maturing Loans`}
                                titleRedirect={`/list?SOURCE=PEAK&type=${TARGET_LIST_MATURING_LOANS}`}
                                columns={[
                                    {key: 'Transactions', value: stats.maturingTransactions},
                                    {key: 'Total Loan Amount', value: stats.maturingLoanAmount},
                                    {key: 'Avg Rate', value: stats.maturingAvgRate}
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
